import axios from 'axios';
import { LogoutAction } from '../redux/actions/authAction';
import { store } from '../redux/store';

const authState: any = store.getState().auth;

// axios.interceptors.request.use(
// 	async (config) => {
// 		config.headers = {
// 			...config.headers,
// 			authorization: `Bearer ${authState.ACCESS_TOKEN}`
// 		};

// 		return config;
// 	},
// 	(error) => Promise.reject(error)
// );

axios.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error.response?.status === 401) {
			store.dispatch(LogoutAction());
		}
		return Promise.reject(error);
	}
);

export const axiosInstance = axios;
